(function() {
    var InvoiceTotalDisplay = function($el) {
        this.$el = $el
        this.$form = this.$el.closest('form')

        this.$form.on('change', '.invoice-charge-input', this.render.bind(this))
        this.$form.on('change', '.invoice-discount-input', this.render.bind(this))

        this.render()
    
        return this
    }

    InvoiceTotalDisplay.prototype.render = function () {
        var total = 0;

        this.$form.find('.invoice-charge-input').each(function() {
            charge = parseFloat($(this).val())

            if (!_.isNaN(charge)) {
                total += charge;
            }
        });

        var discount;

        var discount = this.$form.find('.invoice-discount-input').val();
        discount = parseFloat(discount);

        if (!_.isNaN(discount)) {
            total -= discount;
        }

        this.$el.html(total.toFixed(2));
    }

    $('.invoice-total-display').each(function () {
        new InvoiceTotalDisplay($(this))
    })
})()
